import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestSection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新更新</h2>
          <p className="mt-2 text-sm text-foreground-600">实时追踪你喜爱漫画的最新章节</p>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-background-200/70">
            {latestUpdates.map((item, idx) => (
              <Link
                key={`${item.id}-${idx}`}
                to={`/article/${item.id}`}
                className="flex items-center justify-between px-4 py-3 bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0" />
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-foreground-800 truncate">{item.title}</p>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.chapter}</p>
                  </div>
                </div>
                <span className="text-xs text-foreground-400 flex-shrink-0 ml-3 whitespace-nowrap">{item.time}</span>
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/shaonian"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 border border-background-300 text-foreground-700 text-sm font-medium hover:bg-primary-50 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>查看全部更新</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}